import { gql } from "@apollo/client";

export const GET_COMPANY_WITH_ADDRESS = gql`
  query getCompanyWithAddress(
    $id: ID!
    $company_In: [ID]
    $limit: Int
    $offset: Int
    $orderBy: [String]
  ) {
    getCompany(id: $id) {
      id
      name
      displayName
      vatNumber
      euVatNumber
      intracomVatNr
      capitalAmount
      website
      phone1
      email
      rcs
      legalStructure {
        code
        name
      }
      legalCategory {
        code
        name
      }
      businessActivity {
        code
        name
      }
    }
    listAddresses(filter: { addressType: "main", company_In: $company_In }) {
      totalCount
      results(limit: $limit, offset: $offset, orderBy: $orderBy) {
        id
        addressType {
          label
          value
        }
        addressNr
        city
        country {
          name
          code
        }
        postalCode
        addressBtq
        address3
        address2
        address1
      }
    }
  }
`;

export const LIST_COMPANY_MAIN_BANK_ACCOUNT = gql`
  query listCompaniesBankAccountsPaginated(
    $companyId: ID
    $limit: Int
    $offset: Int
    $orderBy: [String]
  ) {
    listCompaniesBankAccountsPaginated(
      filter: { companyId: $companyId, isMain: true, isActive: true }
    ) {
      totalCount
      results(limit: $limit, offset: $offset, orderBy: $orderBy) {
        id
        iban
        bic
        bankDescription
        name
        sepaCredentialIdentifier
        isMain
        currency
        isActive
      }
    }
  }
`;
